import { render } from "./IdentifyCode.vue?vue&type=template&id=cbdf8abe&scoped=true"
import script from "./IdentifyCode.vue?vue&type=script&lang=js"
export * from "./IdentifyCode.vue?vue&type=script&lang=js"

import "./IdentifyCode.vue?vue&type=style&index=0&id=cbdf8abe&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbdf8abe"]])

export default __exports__